import {cloneDeep} from "lodash";

export function customSort<T>(
    currentSort: string,
    currentSortOrder: string,
    value:T[]
):T[] {
    return value.sort(dynamicSort(currentSort, currentSortOrder));
}

export function dynamicSort(currentSort: string, currentSortOrder: string) {
    return (a:any, b:any) => {
        let sortA: any = cloneDeep(a);
        let sortB: any = cloneDeep(b);
        const sortBy = currentSort;

        if (typeof a[sortBy] === 'number' || typeof b[sortBy] === 'number') {
            if (currentSortOrder === "desc") {
                if (a[sortBy] < b[sortBy]) return 1;
                if (a[sortBy] > b[sortBy]) return -1;
                if (!a[sortBy]) return 1;   // когда аттрибут не задан (напр. bulk_id undefined)
                if (!b[sortBy]) return -1;
            }
            if (a[sortBy] > b[sortBy]) return 1;
            if (a[sortBy] == b[sortBy]) return 0;
            if (a[sortBy] < b[sortBy]) return -1;
            if (!a[sortBy]) return -1;
            if (!b[sortBy]) return 1;
        }
        // когда переменные является массовом или объектом, то делается join и сортируется
        if (Array.isArray(sortA[sortBy]) || Array.isArray(sortB[sortBy])) {
            sortA[sortBy] = a[sortBy]?.join(' ');
            sortB[sortBy] = b[sortBy]?.join(' ');
        }
        if (currentSortOrder === "desc") {
            if (!sortB[sortBy]) sortB[sortBy] = '';
            return sortB[sortBy].localeCompare(sortA[sortBy]);
        }
        if (!sortA[sortBy]) sortA[sortBy] = '';
        return sortA[sortBy].localeCompare(sortB[sortBy]);
    }
}

export function removeItem<T>(arr: T[]|undefined, value: T): T[] {
    if (arr) {
        const index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    } else {
        return [];
    }
}
